import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
export default {
    methods: {
        GetBuessionPartList() {
            var Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,

            };
            $http.get("api/Agent/GetBuessionPartList", Params).then(res => {
                let {
                    StateCode,
                    StateMsg,
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.DepartmentList = Data;
                    this.totalSize = Cnt

                })
            })
        },
        // 修改POST /api/Agent/ModifyBuessionPart
        ModifyBuessionPart() {
            $http.post("api/Agent/ModifyBuessionPart", this.form).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '新增成功！',
                        type: 'success'
                    });
                });
                this.form.Name = ''
                this.$emit('updata')
                this.GetBuessionPartList()
            });
        },
        // 删除POST /api/Agent/DelBuessionPart
        DelList(params) {
            $http.post("api/Agent/DelBuessionPart", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: "删除成功",
                        type: 'success'
                    });
                    this.$emit('updata', params)
                    this.GetBuessionPartList()
                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Agent/AddEmployee/components/addDepartment/services.js